import { FC, useEffect, useRef, useState } from 'react'
import { useAuth } from 'react-oidc-context'
import { useParams } from 'react-router-dom'

import { CardContainer } from '../../components/CardContainer/CardConteiner'
import MentorCard from '../../components/Cards/MentorCard'
import { ParallaxCarousel } from '../../components/ParallaxCarousel'
import { useMentorsState } from '../../hooks/storeHooks/useMentors'
import useOnScreen from '../../hooks/useOnScreen'
import { useScrollToTop } from '../../hooks/useScrollToTop'
import { MentorBase } from '../../types/mentor'
import { useMentors } from './useMentors'

const { MODE } = import.meta.env

const HomePage: FC = () => {
  const { slug } = useParams()
  const { favoriteMentors } = useMentorsState()
  const observerTarget = useRef<HTMLDivElement | null>(null)
  const { mentors, hasNextChunk, setNextPage } = useMentors(slug)
  const needLoadMore = useOnScreen(observerTarget, [!!mentors.length])
  useScrollToTop()

  const { isAuthenticated, signinRedirect } = useAuth()

  // This is a hack to force re-render of MentorCard component
  const [renderCount, setRenderCount] = useState(0)

  useEffect(() => {
    setRenderCount(prev => prev + 1)
  }, [mentors])

  useEffect(() => {
    if (needLoadMore && hasNextChunk) {
      setNextPage()
    }
  }, [needLoadMore, hasNextChunk])

  const isDevelopment = MODE === 'development'

  return (
    <>
      <div className="tc-mv-main-container">
        {isDevelopment && <ParallaxCarousel />}
        <CardContainer
          title={
            <div className="text-white mt-8 mb-4 flex items-center text-xl">
              <i className="fa-solid fa-star text-base me-2" />
              Companions
            </div>
          }
          dataTestId="companion-cards-container"
        >
          {!!mentors.length && (
            <>
              {mentors.map((mentor: MentorBase) => (
                <MentorCard
                  key={mentor.mentorId}
                  profile={mentor}
                  renderCount={renderCount}
                  isAuthenticated={isAuthenticated}
                  isFavorite={favoriteMentors.includes(mentor.mentorId)}
                  location="/"
                  signinRedirect={signinRedirect}
                />
              ))}
              <div
                ref={observerTarget}
                className="pb-8 absolute bottom-0 w-full -z-10"
              />
            </>
          )}
        </CardContainer>
      </div>
    </>
  )
}

export default HomePage
